import * as React from 'react';

import { Button } from '@wix/wix-base-ui';

import openExternalUrl from '../../utils/openExternalUrl';

import { BI_EVENTS } from '../../constants';
import { Link, WithSendBi } from '../../types';

interface ICardPrimaryButtonProps extends Link, WithSendBi {
  id: string;
  position: number;
}

const CardPrimaryButton: React.FunctionComponent<ICardPrimaryButtonProps> = (
  props,
) => {
  const onButtonClick = () => {
    openExternalUrl(props.value);

    props.sendBI(BI_EVENTS.CARD_CTA, {
      card_position: props.position,
      announcement_id: props.id,
      button_name: props.text,
      button_type: 'main',
    });
  };

  return (
    <Button onClick={onButtonClick} className="btn-md">
      {props.text}
    </Button>
  );
};

CardPrimaryButton.displayName = 'CardPrimaryButton';

export default CardPrimaryButton;
